import { render, staticRenderFns } from "./SnippetEditorDialog.vue?vue&type=template&id=4ce38fb7&scoped=true&"
import script from "./SnippetEditorDialog.vue?vue&type=script&lang=js&"
export * from "./SnippetEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./SnippetEditorDialog.vue?vue&type=style&index=0&id=4ce38fb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce38fb7",
  null
  
)

export default component.exports